import Loadable from '../../components/loadable';

const ContactUsFormSubmissionsReport = Loadable({
  loader: () => import('../../pages/reports/contact_us_form_submissions'),
});

angular.module('gym').value('ContactUsFormSubmissionsReport', ContactUsFormSubmissionsReport);
